import { render, staticRenderFns } from "./CreateMemorandumModal.vue?vue&type=template&id=510ed3d4"
import script from "./CreateMemorandumModal.vue?vue&type=script&lang=js"
export * from "./CreateMemorandumModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports